import Vue from 'vue'
import App from './App.vue'
import vuetify from './plugins/vuetify';
import store from './store';
import router from './router'
import VueI18n from 'vue-i18n'
import messages from './i18n/i18n'
import interceptor from './utils/interceptor'
import './assets/css/main.css';

Vue.config.productionTip = false

Vue.use(VueI18n)

Vue.use(vuetify, {
  theme: {
    primary: '#32395e'
  }
})

const i18n = new VueI18n({
  messages,
  locale: 'en',
  fallbackLocale: 'en'
})

interceptor()

new Vue({
  //created,
  store,
  i18n,
  router,
  vuetify,
  render: h => h(App)
}).$mount('#app')

//const created = ()=>{
//  console.log("created");
//}

// able to initiate state here, but this request fails without auth
// store.dispatch('getConfig')